{
  "welcome": "Welcome to Djayma",
  "greeting": "Hello!",
  "tagline": "Everything you need, delivered to you",
  "search": "Search for a product...",
  "voice_search": "Voice search",
  "cart": "Cart",
  "my_account": "My account",
  "login": "Log in",
  "register": "Sign up",
  "logout": "Log out",
  "buy_now": "Buy",
  "add_to_cart": "Add to cart",
  "added_to_cart": "Added to cart",
  "view_cart": "View cart",
  "articles": "items",
  "items": "items",
  "fcfa": "FCFA",
  "loading": "Loading...",
  "error": "Something went wrong",
  "retry": "Try again",
  "back_home": "Back to home",
  "not_found": "Page not found",
  "not_found_desc": "This page doesn't exist or has been moved.",
  "privacy_policy": "Privacy policy",
  "terms": "Terms of service",
  "contact": "Contact",
  "phone": "Phone",
  "email": "Email",
  "address": "Address",
  "language": "Language",
  "all_brands": "All brands",
  "all_products": "All products",
  "footer_desc": "Your digital market — Quality products delivered to your door in Dakar.",
  "newsletter": "Newsletter",
  "newsletter_placeholder": "Your email",
  "subscribe": "Subscribe",
  "rights": "All rights reserved",
  "your_cart": "Your Cart",
  "cart_empty": "Your cart is empty",
  "cart_empty_desc": "Browse our catalog and add products to start your order.",
  "see_catalog": "Browse catalog",
  "articles_count_one": "{{count}} item",
  "articles_count_other": "{{count}} items",
  "articles_count": "{{count}} item",
  "articles_count_plural": "{{count}} items",
  "subtotal": "Subtotal excl. tax",
  "tva": "VAT (18%)",
  "total_ttc": "Total incl. tax",
  "delivery_label": "Delivery",
  "delivery_next_step": "Calculated at next step",
  "min_order_warning": "Minimum order: {{amount}}. You need {{remaining}} more.",
  "min_units": "Minimum: {{count}} units",
  "close": "Close",
  "menu": "Menu",
  "continue_shopping": "Continue shopping",
  "decrease_qty": "Decrease quantity",
  "discover": "Discover",
  "increase_qty": "Increase quantity",
  "quantity_label": "Quantity: {{count}}",
  "proceed_to_order": "Place order",
  "total_weight": "Total weight: {{weight}} kg",
  "remove_item": "Remove",
  "summary": "Summary",
  "call_us": "Call us",
  "error": {
    "generic_title": "Something went wrong",
    "refresh_page": "Refresh the page"
  },
  "errors": {
    "rateLimited": "Too many requests. Please wait {{seconds}} seconds.",
    "serverError": "Something went wrong. Please try again.",
    "unauthorized": "Session expired. Please log in again.",
    "networkError": "Connection problem. Check your internet."
  },
  "accessibility": {
    "skip_to_content": "Skip to content"
  },
  "contact_page": {
    "seo_title": "Contact",
    "seo_description": "Contact CIEDA — Compagnie Import Export & Distribution Africaine. Dakar, Senegal.",
    "title": "Contact us",
    "subtitle": "Have a question, a special order, or a wholesale request? Our team replies quickly.",
    "call": {
      "title": "Call us",
      "description": "Speak directly with our sales team in French or Wolof."
    },
    "whatsapp": {
      "title": "WhatsApp",
      "description": "The fastest way to confirm an order or ask a product question.",
      "cta": "Open WhatsApp"
    },
    "email": {
      "title": "Email",
      "description": "Send us a detailed message and we'll reply within 24 business hours."
    },
    "address": {
      "title": "Address",
      "description": "Compagnie Import Export & Distribution Africaine — Hann Mariste II, Dakar, Senegal."
    },
    "hours": {
      "title": "Business hours",
      "weekdays": "Monday – Friday: 8am – 6pm (GMT)",
      "weekend": "Saturday: 9am – 2pm (GMT) · Sunday: closed"
    }
  },
  "not_found": {
    "seo_title": "Page not found",
    "seo_description": "The page you're looking for doesn't exist or has been moved.",
    "title": "Page not found",
    "prefix": "The page",
    "suffix": "doesn't exist or has been moved.",
    "back_home": "Back to home",
    "view_catalog": "View catalog",
    "popular_heading": "Popular pages",
    "popular": {
      "home": "Home",
      "catalog": "Product catalog",
      "cart": "My cart",
      "account": "My account",
      "privacy": "Privacy policy",
      "terms": "Terms and conditions"
    }
  }
}
